<template>
  <div class="scrollable-menu">
    <div class="scrollable-menu__container container">
      <div
        class="icon nav-toggler"
        @click="$nav.show()"
      >
        <f-sprite-icon :icon-link="$options.icons.IconNav" />
      </div>

      <a
        class="scrollable-menu__logo"
        href="/"
      >
        <f-sprite-icon :icon-link="$options.icons.IconLogo" />
      </a>

      <client-only>
        <tree-menu
          :items="MENU"
          :max-depth="3"
        />

        <menu-icons location="scrollable-menu" />
      </client-only>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/* Icons */
import IconNav from '@icons/nav-toggler.svg';
import IconLogo from '@images/logo-short.svg';

import MenuIcons from './menu-icons.vue';
import treeMenu from './tree-menu.vue';

export default {
  name: 'scrollable-menu',

  components: {
    treeMenu,
    MenuIcons,
  },

  inject: ['adaptive'],

  icons: {
    IconLogo,
    IconNav,
  },

  computed: {
    ...mapGetters({
      MENU: 'menu/mainMenu',
    }),
  },
};
</script>

<style lang="scss">
.scrollable-menu {
  background: $white;

  &__logo {
    display: flex;
    align-items: center;
    align-self: stretch;
    flex-shrink: 0;
    width: 30px;
    color: $blue;

    svg {
      height: 10px;
    }
  }

  &__container {
    display: flex;
    align-items: center;

    > .link {
      display: none;
    }
  }
}

@include breakpoint("tablet") {
  .scrollable-menu {
    @include stacking("sticky-header");
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    border-bottom: 1px solid $gray_lu;
    // stylelint-disable-next-line color-function-notation
    box-shadow: 0 4px 32px rgb(0 0 0 / .08);

    &__logo {
      margin-right: 22px;
    }

    .tree-menu.depth1 {
      margin-right: 52px;

      .root-categories {
        flex-wrap: wrap;
        height: 48px;
        padding: 0;

        > li {
          display: flex;
          height: 48px;
          padding: 0 12px;

          &:first-child {
            padding-left: 0;
          }

          &:last-child {
            padding-right: 0;
          }

          > .link {
            padding: 0;
            margin: 0;
            white-space: nowrap;
          }
        }
      }
    }

    .icons {
      align-items: center;
      margin-top: 4px;
    }
  }
}

@include breakpoint("desktop") {
  .scrollable-menu {
    padding-right: var(--scroll-bar-width, 0);

    .nav-toggler {
      display: none;
    }

    &__container > .link {
      display: flex;
      margin-left: 34px;
      padding: 7px 0;
      color: $black;
      font-size: 14px;
      line-height: 16px;
    }

    .control-user {
      align-self: flex-end;
      padding-bottom: 8px;
    }

    .control-cart {
      align-self: flex-end;
      padding-bottom: 8px;

      &__wrap {
        flex-wrap: nowrap;
      }
    }

    .icons {
      column-gap: 40px;
    }
  }
}
</style>
